import Vue from 'vue'

export const useToast = () => {
  // `options` merges over the global vue-toasted config (main.js), so a caller
  // can override just what it needs. Omitting it keeps the global defaults.
  const showToast = (message, type = 'success', options = {}) =>
    Vue.prototype.$toasted.show(message, {
      type,
      ...options
    })

  return {
    showToast
  }
}
